
export class EInvoiceSearchDto {
     transaction_amount: number
     transaction_date: Date
     invoiceNo: string
     serverDocType: string
}